module.exports = __webpack_public_path__ + "static/media/wide.ae2fdaa3.jpg";